import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';
import { InputLabelContainer } from '../../../../../../common/components/form/label/containers/input-label.container';
import { currency } from '../../../../../../common/services/common.service';

export default function VoucherItemInfoComponent({
  handleInnerFormChange, selectedVouchers, invoiceNumbersList
}: any) {

  return (
    <>
      <AccordionContainer
        child={
          <>
            <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
              {selectedVouchers?.PaymentReferanceType !== 20 && (
                <InputContainer
                  label="Invoice Number"
                  labelField="InvoiceNumber"
                  list={invoiceNumbersList}
                  onValueChange={(event: any, newValue: any) => {
                    handleInnerFormChange(
                      event.target.value,
                      'InvoiceNumber'
                    );
                  }}
                  optionName='Choose Invoice Number'
                  type="select"
                  value={selectedVouchers?.InvoiceNumber}
                  valueField="InvoiceNumber"
                />
              )}
              {selectedVouchers?.PaymentReferanceType === 20 && (
                <InputContainer
                  label="New Reference Number"
                  labelField="NewReferenceNumber"
                  onValueChange={(event: any, newValue: any) => {
                    handleInnerFormChange(
                      event.target.value,
                      'NewReferenceNumber'
                    );
                  }}
                  type="text"
                  value={selectedVouchers?.NewReferenceNumber}
                />
              )}
              <InputContainer
                label="Voucher Amount"
                name="VoucherAmount"
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'VoucherAmount'
                  );
                }}
                type="number"
                value={selectedVouchers?.VoucherAmount}
              />
            </div>
            <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
              <div>
                <div className='font-semibold text-sm'>
                  <InputLabelContainer
                    label="Balance Amount To be Paid"
                  />
                </div>
                <div className='text-xs'>
                  <InputLabelContainer
                    label={currency(selectedVouchers?.BalanceAmountTobePaid || '0')}
                  />
                </div>
              </div>
              <div>
                <div className='font-semibold text-sm'>
                  <InputLabelContainer
                    label="Paid Amount"
                  />
                </div>
                <div className='text-xs'>
                  <InputLabelContainer
                    label={currency(selectedVouchers?.PaidAmount || '0')}
                  />
                </div>
              </div>
              <div>
                <div className='font-semibold text-sm'>
                  <InputLabelContainer
                    label="Total Amount"
                  />
                </div>
                <div className='text-xs'>
                  <InputLabelContainer
                    label={currency(selectedVouchers?.TotalAmount || '0')}
                  />
                </div>
              </div>
            </div>
          </>
        }
        expandedPanel="userInfo"
        headerTitle="Item Information"
      />
    </>
  )
}